






























































































import Vue from 'vue'
import ProgressBar from '@/components/sub-components/ProgressBar.vue'
import ProgressCircle from '@/components/sub-components/ProgressCircle.vue'
import BarChartWithRatio from '@/components/care-team-dashboard/BarChartWithRatio.vue'
import { round, withUnit } from '@/components/exercises/measure/filters'
import { round as lodashRound } from 'lodash-es'

export const SiteStatsCardType = {
  interactions: 'interactions',
  adherence: 'adherence',
  recruitment: 'recruitment',
  events: 'events',
  vitals: 'vitals',
}

export default Vue.extend({
  components: {
    ProgressBar,
    ProgressCircle,
    BarChartWithRatio,
  },
  filters: {
    withUnit,
    round,
  },
  props: {
    siteStatses: {
      type: Array,
      default: null,
    },
    type: {
      type: String,
      required: true,
      validate: type => Object.keys(this.types).includes(type),
    },
    icon: {
      type: String,
      default: '',
    },
    iconLoading: {
      type: Boolean,
      default: false,
    },
    iconEvents: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      types: SiteStatsCardType,
    }
  },
  computed: {
    averageAdherence(): number {
      return lodashRound(
        this.siteStatses.reduce((acc, siteStats) => siteStats.siteAvgAdherencePerc + acc, 0) / this.siteStatses.length
      )
    },
  },
})
